import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import URI from 'URIjs'

import VoteList from '../components/VoteList'
import {VisibilityFilter} from '../components/VoteListFilters'
import {uncover, voteBack} from '../state/actions/votes'


const NoVotes = (props) => <p>Kortelių nėra.</p>

@connect(
    state => ({
      page: state.votes.votes.page,
        currentView: state.votes.votes.currentView,
        hiddenVotes: state.votes.votes.hidden.votes,
        hiddenCount: state.votes.votes.hidden.count,
        visibleVotes: state.votes.votes.visible.votes,
        visibleCount: state.votes.votes.visible.count
    }),
    dispatch => bindActionCreators({uncover, voteBack}, dispatch))
export default class Votes extends Component {

  constructor(props) {
    super(props)
    this.filterAvailableForOrdinaryMembers = true
    }

    renderBoth(player, url) {
        const { hiddenVotes, hiddenCount, visibleVotes, visibleCount, locationFilter, ageFilter, orderBy, gameType } = this.props
        const { uncover, voteBack } = this.props

        const visibleVotesPartial =
            <VoteList votes={visibleVotes}
                count={visibleCount}
                pagerVisible={false}
                className=''
                limit={10}
                voteBack={voteBack}
                gameType={gameType}
                showMore={{ title: 'Visos atidengtos', url: url.clone().setQuery('rodomi', 'atidengti') }} />

        const hiddenVotesPartial =
            <VoteList votes={hiddenVotes}
                count={hiddenCount}
                pagerVisible={false}
                className=''
                uncover={uncover}
                limit={20}
                voteBack={voteBack}
                gameType={gameType}
                showMore={{ title: 'Visos neatidengtos', url: url.clone().setQuery('rodomi', 'neatidengti') }} />


        const votesPartial = <div>
            <div className='pal-closed'>
                <h5>Neatidengti</h5>
                {hiddenCount > 0 ? hiddenVotesPartial : <NoVotes />}
            </div>
            <div className='pal-opened'>
                <h5>Atidengti</h5>
                {visibleCount > 0 ? visibleVotesPartial : <NoVotes />}
            </div>
        </div>

        return <div className='pal-cards'>
            {hiddenCount > 0 || visibleCount > 0 ? votesPartial : <NoVotes />}
        </div>
    }

    renderHidden(player, url) {
        const { hiddenVotes, hiddenCount, uncover, voteBack, page, currentView, locationFilter, ageFilter, orderBy, gameType } = this.props

        const hiddenVotesPartial =
            <VoteList votes={hiddenVotes}
                count={hiddenCount}
                uncover={uncover}
                voteBack={voteBack}
                page={page}
                pagerHash='v1'
                gameType={gameType}
                pageParamName='puslapis' />

        return <div className='pal-cards'>
            <div className='pal-filters'><h5>Išfiltruok korteles</h5>
                <VisibilityFilter currentView={currentView} url={url} />
            </div>
            {hiddenCount > 0 ? hiddenVotesPartial : <NoVotes />}
        </div>
    }

    renderVisible(player, url) {
        const { visibleVotes, visibleCount, voteBack, page, currentView, locationFilter, ageFilter, orderBy, gameType } = this.props

        const visibleVotesPartial =
            <VoteList votes={visibleVotes}
                count={visibleCount}
                voteBack={voteBack}
                page={page}
                pagerHash='v1'
                gameType={gameType}
                pageParamName='puslapis' />

        return <div className='pal-cards'>
            <div className='pal-filters'><h5>Išfiltruok korteles</h5>
                <VisibilityFilter currentView={currentView} url={url} />
            </div>
            {visibleCount > 0 ? visibleVotesPartial : <NoVotes />}
        </div>
    }

  render() {

    const url = new URI(window.document.location.href).hash('#v1')
    const player = this.props.player

      const { votes, count, page, gameType } = this.props
    const {uncover, voteBack} = this.props

      switch (this.props.currentView) {
          case 'VisibleVotes': return this.renderVisible(player, url);
          case 'HiddenVotes': return this.renderHidden(player, url);
          default: return this.renderBoth(player, url);
      }
  }
}
